import React from 'react';
import { translate } from '../../../../../../common/intl';
import { CustomTreeListColumnProps } from '../../../../../components/common/treelist/types';
import { MODE_FIELD } from '../constants';
import { ActionsCell } from '../column.templates/Actions';
import IDCell from '../column.templates/IDCell';

export const TreeListLHRTSchema = ({
  actionsClass,
  popperHolder,
  getItem,
  onDiscard,
  onDelete,
  onConfirm,
  parentRevId,
  onRowClick,
}): CustomTreeListColumnProps[] => [
  {
    id: 'title',
    field: 'title',
    headerClassName: 'pre-actions-header',
    title: translate('form.builder.procedure.equipment.grid.title'),
    mainOrderIndex: 1,
    cell: (props) => <IDCell {...props} getItem={getItem} onClick={onRowClick} />,
  },
  {
    id: 'actions',
    locked: false,
    cell: (props) => (
      <td className={actionsClass}>
        {Boolean(props.dataItem[MODE_FIELD]) && (
          <ActionsCell
            {...props}
            onConfirm={onConfirm}
            onDiscard={onDiscard}
            rootClassName={popperHolder}
          />
        )}
      </td>
    ),
    width: 0,
  },
];
